import { render } from "./AccountConfirm.vue?vue&type=template&id=231abf4d&scoped=true"
import script from "./AccountConfirm.vue?vue&type=script&lang=js"
export * from "./AccountConfirm.vue?vue&type=script&lang=js"

import "./AccountConfirm.vue?vue&type=style&index=0&id=231abf4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231abf4d"]])

export default __exports__